import { Layer, Source } from "react-map-gl/mapbox"

interface FloodingLayerProps {
  opacity?: number
}

export const FloodingLayer = ({ opacity = 0.7 }: FloodingLayerProps) => {
  return (
    <>
      <Source
        id="raster-flood1"
        type="raster"
        tiles={[
          "https://mapsref.brgm.fr/wxs/georisques/risques?SERVICE=WMS&VERSION=1.3.0&REQUEST=GetMap&FORMAT=image%2Fpng&TRANSPARENT=true&LAYERS=INOND_01_02&STYLES=&SRS=EPSG%3A3857&CRS=EPSG%3A3857&TILED=false&WIDTH=256&HEIGHT=256&BBOX={bbox-epsg-3857}",
        ]}
        tileSize={256}
        maxzoom={15}
      >
        <Layer id="raster-flood1" type="raster" source="raster-flood1" paint={{ "raster-opacity": opacity }} />
      </Source>
      <Source
        id="raster-flood2"
        type="raster"
        tiles={[
          "https://mapsref.brgm.fr/wxs/georisques/risques?SERVICE=WMS&VERSION=1.3.0&REQUEST=GetMap&FORMAT=image%2Fpng&TRANSPARENT=true&LAYERS=INOND_01_04&STYLES=&SRS=EPSG%3A3857&CRS=EPSG%3A3857&TILED=false&WIDTH=256&HEIGHT=256&BBOX={bbox-epsg-3857}",
        ]}
        tileSize={256}
        maxzoom={15}
      >
        <Layer id="raster-flood2" type="raster" source="raster-flood2" paint={{ "raster-opacity": opacity }} />
      </Source>
      <Source
        id="raster-flood3"
        type="raster"
        tiles={[
          "https://mapsref.brgm.fr/wxs/georisques/risques?SERVICE=WMS&VERSION=1.3.0&REQUEST=GetMap&FORMAT=image%2Fpng&TRANSPARENT=true&LAYERS=INOND_03_01&STYLES=&SRS=EPSG%3A3857&CRS=EPSG%3A3857&TILED=false&WIDTH=256&HEIGHT=256&BBOX={bbox-epsg-3857}",
        ]}
        tileSize={256}
        maxzoom={15}
      >
        <Layer id="raster-flood3" type="raster" source="raster-flood3" paint={{ "raster-opacity": opacity }} />
      </Source>
      <Source
        id="raster-flood4"
        type="raster"
        tiles={[
          "https://mapsref.brgm.fr/wxs/georisques/risques?SERVICE=WMS&VERSION=1.3.0&REQUEST=GetMap&FORMAT=image%2Fpng&TRANSPARENT=true&LAYERS=INOND_03_02&STYLES=&SRS=EPSG%3A3857&CRS=EPSG%3A3857&TILED=false&WIDTH=256&HEIGHT=256&BBOX={bbox-epsg-3857}",
        ]}
        tileSize={256}
        maxzoom={15}
      >
        <Layer id="raster-flood4" type="raster" source="raster-flood4" paint={{ "raster-opacity": opacity }} />
      </Source>
    </>
  )
}
